import { useContext, useEffect } from 'react';
import { SessionContext } from '../contexts';
import { useAppInstance } from './useAppInstance';
export const useNextAppSession = (props) => {
    const { session, status, refreshInProgress } = useContext(SessionContext);
    const { signIn, onSignInError } = useAppInstance();
    const required = props?.required ?? false;
    useEffect(() => {
        if (required && !session && status === 'unauthenticated') {
            signIn().catch((e) => {
                onSignInError?.(e);
            });
        }
    }, [required, session, signIn, onSignInError, status]);
    return { session, status, refreshInProgress };
};
export function createUseSession() {
    return (props) => {
        const { session, status, refreshInProgress } = useNextAppSession(props);
        return { session: session, status, refreshInProgress };
    };
}
